import { ReactNode } from "react";
import commonStyles from "../../../styles/common.module.css"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useMediaQuery } from "@mui/material";
interface Props {
  header: string;
  body: ReactNode;
  buttonLabel: string;
  onClick: () => void;
}

const Success = ({ header, body, buttonLabel, onClick }: Props) => {
   const isSmallScreen = useMediaQuery("(max-width:960px)");
  return (
    <div className={commonStyles.successContainer}>
        <CheckCircleIcon sx={{
          width: isSmallScreen ? "40px" :"82px",
          height: isSmallScreen ? "40px" : "82px",
          color:"var(--color-success-strong)"
        }}/>
        <h1 className={commonStyles.successHeader}>
          {header}
        </h1>
          {body}
        <button onClick={onClick} className={commonStyles.button_primary}>{buttonLabel}</button>
    </div>
  );
};

export default Success;
